import React, { Component } from 'react';
import Button from '../../../../../components/Button';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import Anchor from '../../../../../components/link/Anchor';
import Panel from '../../../../../components/outline/Panel';
import TableTransfer from '../../../../../components/input/TableTransfer';
import { RECOMMEND_BRAND_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import { columns } from './columns';
import { comparePrePropsAndNextProps } from '../../../../../lib/common';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { RECOMMEND_STORE_ITEM_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/recommend/store/models';
import './RecommendStoreSaveItemList.scss';

class RecommendStoreSaveItemList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const {
      form,
      setData,
      recommendStoreItemList,
      getRecommendStoreItemList,
      selectRecommendStoreItemList,
      onDragEndSelectRecommendStoreItemList,
      getRecommendStoreItemListExcelDownload,
      showSubText,
      getSelectedRecommendStoreItemListExcelDownload,
      setRecommendStoreItemListExcelUpload,
    } = this.props;
    const { itemList, selectedItemList } = recommendStoreItemList;

    return (
      <Panel className="recommend-store-save-item-list">
        <div className="panel-header">
          <div className="title">추천 브랜드 아이템 리스트</div>
        </div>

        <div className="panel-body">
          <TableTransfer
            dataSource={itemList.list}
            operations={['연결', '해제']}
            leftTitle="브랜드 리스트"
            rightTitle="선택된 브랜드 리스트"
            leftTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  isFilter: true,
                }),
              headInfo: (
                <div className="recommend-store-item-head">
                  <div className="excel-button-list">
                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={getRecommendStoreItemListExcelDownload}
                    />
                  </div>
                </div>
              ),
              rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
              getList: getRecommendStoreItemList,
              pagination: itemList.pagination,
              sortOption: itemList.sortOption,
              filterOption: itemList.filterOption,
              initialOption: {
                filterOption: RECOMMEND_STORE_ITEM_LIST_FILTER_OPTION_MODEL,
                pagination: _LIST_PAGINATION_MODEL,
              },
            }}
            rightTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  form,
                  showSubText,
                  setData,
                }),
              headInfo: (
                <div className="selected-recommend-store-item-head">
                  <div className="selected-recommend-store-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>

                  <div className="excel-button-list">
                    <Anchor
                      text="브랜드 업로드 템플릿"
                      isUnderLine
                      color="primary"
                      href={RECOMMEND_BRAND_UPLOAD_TEMPLATE_XLSX_URL}
                      target="_blank"
                    />

                    <ExcelUploadForm
                      onChange={(file) => setRecommendStoreItemListExcelUpload(file)}
                      btnText="브랜드 엑셀 업로드"
                    />

                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={getSelectedRecommendStoreItemListExcelDownload}
                    />
                  </div>
                </div>
              ),
              list: selectedItemList.list,
              canDrag: true,
              onDragEnd: (newList) => onDragEndSelectRecommendStoreItemList(newList.list),
            }}
            onChange={(action, moveIdList) => selectRecommendStoreItemList(action, moveIdList)}
          />
        </div>
      </Panel>
    );
  }
}

export default RecommendStoreSaveItemList;
